import aws from '../images/awsXSmall.png'
import gcp from '../images/gcp_x_small.jpg'
import microsoft from '../images/microsoft_x_small.png'

export const getCloudImg = (cloud: string) => {
  if (cloud === 'AWS') {
    return aws
  }

  if (cloud === 'GCP') {
    return gcp
  }

  if (cloud === 'MICROSOFT') {
    return microsoft
  }

  return ''
}
